/**
 * @Author:
 * @Description:
 * @DateTime: Created in 18:26 2018/11/14
 */
import Vue from 'vue'
var Bus = new Vue();
export default Bus

export let Events = {
    StationChange: 'STATION_CHANGE',
    Resize: 'RESIZE',
    DeviceStatusReady: 'DEVICE_STATUS_READY',
    GISStationClick: 'GIS_STATION_CLICK'
}
